import {
    GET_DASHBOARD,
    GET_DASHBOARD_ULTAH,
    GET_DASHBOARD_WAFAT,
    RESET_DASHBOARD,
    SEARCH_PEGAWAI_BY_PENDIDIKAN,
    GET_KOMPARASI_PEGAWAI,
    RESET_DASHBOARD_ULTAH,
    RESET_DASHBOARD_WAFAT,
    RESET_KOMPARASI_PEGAWAI,
    GET_PEGAWAI_BY,
    GET_DASHBOARD_USIA,
    GET_TABLE_DASHBOARD,
    GET_DETAIL_DASHBOARD_USIA,
    RESET_DETAIL_DASHBOARD_USIA,
    GET_DETAIL_DASHBOARD_PANGKAT,
    GET_DETAIL_DASHBOARD_PENSIUN,
    GET_SLKS_DASHBOARD,
    GET_DETAIL_UPT_DASHBOARD,
    GET_MARKER_MAPS_UPT,
    GET_DASHBOARD_V2,
    RESET_PEGAWAI_BY,
    GET_DASHBOARD_PROGRAM_KERJA,
    GET_DASHBOARD_ULTAH_TODAY,
    GET_DASHBOARD_ESELON_1,
    GET_DETAIL_DASHBOARD_ESELON_1,
} from 'shared/constants/ActionTypes';

const defaultDash = {
    result: {
        "jumlah": [],
        "prosentase": [
            {
                "actualName": "ASN",
                "name": "ASN",
                "value": 0,
                "color": "#F6AD1D"
            },
            {
                "actualName": "Non-ASN",
                "name": "Non-Asn",
                "value": 0,
                "color": "#6B7280"
            }
        ],
        "header": [
            {
                "key": '',
                "data": {}
            }
        ],
        "golongan": [
            {
                "nama": '',
                "pangkat": '',
                "total_pegawai": '',
            }
        ],
        "batas_usia_pensiun": [
            {
                "Pria": 0,
                "Wanita": 0,
                "Total": 0,
                "name": 'BUP 58',
            },
        ],
        "slks": [
            {
                "key": 10,
                "data": [
                    {
                        "total": 0,
                        "pria": 0,
                        "wanita": 0
                    },
                ]
            }
        ],
        "programKerja": {
            "counter": {
                "total_program": 0,
                "program_selesai": 0,
                "program_aktif": 0,
                "program_tertunda": 0,
                "rata_rata_realisasi": 0.0,
            },
            chart: {
                option: [],
                lineChart: [],
            }
        }
    }
}

const defaultDashboardUsia = [
    {
        Pria: 0,
        Wanita: 0,
        name: '21-30 Tahun',
    },
    {
        Pria: 30,
        Wanita: 50,
        name: '31-40 Tahun',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: '41-50 Tahun',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: '51-55 Tahun',
    },
    {
        Pria: 0,
        Wanita: 50,
        name: '56-60 Tahun',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: '61-75 Tahun',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: '76-80 Tahun',
    },
]

const defaultDashboardEselon1 = [
    {
        Pria: 0,
        Wanita: 0,
        name: 'BPPMKHP',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'BPPSDMKP',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'Dirjen PDS',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'Dirjen PKRL',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'Dirjen PSDKP',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'DJPB',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'DJPT',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'Itjen',
    },
    {
        Pria: 0,
        Wanita: 0,
        name: 'Setjen',
    },
]

const defaultDetailDashboardUsia = [
    {

        name: "SD",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "SLTP",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "SLTA",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "D1",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "D2",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "D3",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "D4",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "S1",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "S2",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
    {
        name: "S3",
        Pria: 0,
        Wanita: 0,
        total: 0
    },
]

const placeholderData = {
    results: []
}

const INIT_STATE = {
    data: { ...defaultDash },
    dataV2: { ...defaultDash },
    table: {
        result: []
    },
    ulangTahun: {
        today: placeholderData,
        month: placeholderData,
    },
    wafat: {
        result: []
    },
    searchResult: placeholderData,
    komparasiPegawai: null,
    pegawaiBy: null,
    usia: {
        list: defaultDashboardUsia,
        detail: defaultDetailDashboardUsia,
    },
    golongan: {
        list: {
            results: []
        }
    },
    pensiun: {
        list: {
            results: []
        }
    },
    upt: {
        markers: [],
        list: {
            results: []
        },
        detail: {
            results: []
        },
    },
    dashEselon1: {
        list: {
            result: defaultDashboardEselon1
        },
        detail: {
            results: []
        }
    }
}

const dashboardReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DASHBOARD: {
            let sortedKeys = []
            let expectedResultJumlah = []
            let expectedResultHeader = []
            let expectedResultProsentase = []
            let expectedResultBUP = []
            let dataDashboard = action.payload
            const dataJumlah = [...dataDashboard.result.jumlah]
            const dataHeader = { ...dataDashboard.result.header }
            const dataProsentase = [...dataDashboard.result.prosentase]
            const dataBUP = { ...dataDashboard.result.batas_usia_pensiun }

            if (dataJumlah.length > 0 && dataJumlah.some(item => item.name === "Lainnya")) {
                expectedResultJumlah = dataJumlah.filter(item => {
                    if (item.name !== "Lainnya") sortedKeys.push(item.name) // Mengambil urutan key dari data jumlah untuk disamakan dengan urutan key di data prosentase
                    return item.name !== "Lainnya"
                })
                if (expectedResultJumlah.length > 0) {  // Jika expected result jumlah tidak kosong, maka proses data jumlah dan prosentase
                    sortedKeys = [...sortedKeys, "Lainnya"]
                    const keyOrderMap = Object.fromEntries(sortedKeys.map((name, index) => [name, index]))

                    Object.keys(dataHeader).map((key) => {
                        expectedResultHeader.push({ key: key, data: dataHeader[key] })
                    })

                    Object.keys(dataBUP).map((key) => {
                        expectedResultBUP.push({ ...dataBUP[key], "name": key })
                    })

                    expectedResultJumlah.push(dataJumlah.find(item => item.name === "Lainnya"))
                    expectedResultProsentase = dataProsentase.sort((a, b) => (keyOrderMap[a.name] - keyOrderMap[b.name]))
                }
            } else expectedResultJumlah = dataJumlah

            dataDashboard['result']['header'] = expectedResultHeader
            dataDashboard['result']['jumlah'] = expectedResultJumlah
            dataDashboard['result']['prosentase'] = expectedResultProsentase
            dataDashboard['result']['batas_usia_pensiun'] = expectedResultBUP
            dataDashboard['result']['slks'] = [...state.data?.result?.slks]
            dataDashboard['result']['programKerja'] = { ...state.data?.result.programKerja }

            return {
                ...state,
                data: dataDashboard,
            }
        }
        case GET_DASHBOARD_V2: {
            return {
                ...state,
                dataV2: action.payload,
            }
        }
        case GET_TABLE_DASHBOARD: {
            const data = [...action.payload.result.data]
            const expectedResult = transformData(data)

            return {
                ...state,
                table: {
                    result: expectedResult
                }
            }
        }
        case RESET_DASHBOARD: {
            return {
                ...state,
                data: defaultDash
            }
        }
        case GET_DASHBOARD_ULTAH: {
            return {
                ...state,
                ulangTahun: {
                    ...state.ulangTahun,
                    month: action.payload,
                }
            }
        }
        case GET_DASHBOARD_ULTAH_TODAY: {
            return {
                ...state,
                ulangTahun: {
                    ...state.ulangTahun,
                    today: action.payload,
                }
            }
        }
        case RESET_DASHBOARD_ULTAH: {
            return {
                ...state,
                ulangTahun: {
                    today: placeholderData,
                    month: placeholderData,
                }
            }
        }
        case GET_DASHBOARD_WAFAT: {
            return {
                ...state,
                wafat: action.payload
            }
        }
        case SEARCH_PEGAWAI_BY_PENDIDIKAN: {
            return {
                ...state,
                searchResult: action.payload
            }
        }
        case RESET_DASHBOARD_WAFAT: {
            return {
                ...state,
                wafat: null
            }
        }
        case GET_KOMPARASI_PEGAWAI: {
            return {
                ...state,
                komparasiPegawai: action.payload
            }
        }
        case RESET_KOMPARASI_PEGAWAI: {
            return {
                ...state,
                komparasiPegawai: null
            }
        }
        case GET_PEGAWAI_BY: {
            return {
                ...state,
                pegawaiBy: action.payload
            }
        }
        case RESET_PEGAWAI_BY: {
            return {
                ...state,
                pegawaiBy: null
            }
        }
        case GET_DASHBOARD_USIA: {
            const data = [...action.payload?.result?.data]
            const expectedResult = transformDataDashboardUsia(data, 'list')
            return {
                ...state,
                usia: {
                    ...state.usia,
                    list: expectedResult
                }
            }
        }
        case GET_DETAIL_DASHBOARD_USIA: {
            const data = [...action.payload?.result?.data]
            const expectedResult = transformDataDashboardUsia(data, 'detail')
            return {
                ...state,
                usia: {
                    ...state.usia,
                    detail: expectedResult
                }
            }
        }
        case RESET_DETAIL_DASHBOARD_USIA: {
            return {
                ...state,
                usia: {
                    ...state.usia,
                    detail: defaultDetailDashboardUsia
                }
            }
        }
        case GET_DETAIL_DASHBOARD_PANGKAT: {
            return {
                ...state,
                golongan: {
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_DASHBOARD_PENSIUN: {
            return {
                ...state,
                pensiun: {
                    list: action.payload
                }
            }
        }
        case GET_SLKS_DASHBOARD: {
            let data = action.payload.result
            let expectedResult = []
            let dataDashboard = { ...state.data }

            Object.keys(data).map((key) => {
                expectedResult.push({ key: key, data: data[key] })
            })

            dataDashboard['result']['slks'] = expectedResult
            return {
                ...state,
                data: dataDashboard
            }
        }
        case GET_DETAIL_UPT_DASHBOARD: {
            let data = action.payload
            return {
                ...state,
                upt: {
                    ...state.upt,
                    detail: data
                }
            }
        }
        case GET_MARKER_MAPS_UPT: {
            let tmpData = []
            let datas = [...action.payload.result.data]
            tmpData = datas.map((item, index) => ({
                code: item.kode,
                name_original: item?.nama_original,
                name: item?.nama,
                color: item?.color,
                latLng: [
                    parseInt(item?.lat),
                    parseInt(item?.long),
                ]
            }))
            return {
                ...state,
                upt: {
                    ...state.upt,
                    markers: tmpData,
                }
            }
        }
        case GET_DASHBOARD_PROGRAM_KERJA: {
            return {
                ...state,
                data: {
                    ...state.data,
                    result: {
                        ...state.data.result,
                        programKerja: {
                            ...state.data.result.programKerja,
                            counter: action.payload?.result,
                            // chart: {
                            //     ...state.data.result.programKerja.chart,
                            //     lineChart: chart_data,
                            //     option: transformDashboardProgramKerja(chart_data),
                            // }
                            chart: {
                                ...state.data.result.programKerja.chart,
                                lineChart: action.payload.result.chart_data,
                                option: transformDashboardProgramKerja(action.payload.result.chart_data),
                            }
                        }
                    }
                }
            }
        }
        case GET_DASHBOARD_ESELON_1: {
            return {
                ...state,
                dashEselon1: {
                    ...state.dashEselon1,
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_DASHBOARD_ESELON_1: {
            return {
                ...state,
                dashEselon1: {
                    ...state.dashEselon1,
                    detail: action.payload
                }
            }
        }
        default:
            return state;
    }
};

const pendidikan = {
    'Sekolah Dasar': 'SD',
    'SLTP': 'SLTP',
    'SLTA': 'SLTA',
    'Diploma I': 'D1',
    'Diploma II': 'D2',
    'Diploma III/Sarjana Muda': 'D3',
    'Diploma IV': 'D4',
    'S-1/Sarjana': 'S1',
    'S-2': 'S2',
    'S-3/Doktor': 'S3',
    'Profesi': 'Profesi',
}

const generatePastelColor = (seed) => {     // from chatgpt
    const hash = Array.from(seed).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
    const h = Math.abs(hash) % 360;
    const s = 70 + (Math.abs(hash) % 10);
    const l = 75;
    return `hsl(${h}, ${s}%, ${l}%)`;
}

const transformDashboardProgramKerja = (data) => {
    let tmpOption = []
    let keySet = new Set()  // for collect all keys in data

    // loop all data and store it first in keySet data
    for (let i = 0; i < data.length; i++) {
        const item = data[i]
        for (let key in item) {
            if (key !== 'bulan') {
                keySet.add(key)
            }
        }
    }

    // loop all key in keySet and push it into tmpOption for Option data chart
    for (let key of keySet) {
        tmpOption.push({
            name: key,
            color: generatePastelColor(key)
        })
    }

    return tmpOption
}

const transformData = (data) => {
    return data.map((unit) => {
        const genderData = [
            { jenis_kelamin: "Laki-laki", key: "pria" },
            { jenis_kelamin: "Perempuan", key: "wanita" },
            { jenis_kelamin: "Total", key: "total" },
        ];

        return genderData.map(({ jenis_kelamin, key }) => ({
            kode: unit.UNIT_CODE,
            nama: unit.UNIT_NAMA,
            jenis_kelamin,
            pusat_pns: unit.PUSAT.PNS[key] ?? null,
            pusat_pppk: unit.PUSAT.PPPK[key] ?? null,
            pusat_jpt_non_asn: unit.PUSAT["JPT Non PNS"][key] ?? null,
            pusat_kontrak: unit.PUSAT.Kontrak[key] ?? null,
            pusat_outsource: unit.PUSAT.Outsource[key] ?? null,
            upt_pns: unit.UPT.PNS[key] ?? null,
            upt_pppk: unit.UPT.PPPK[key] ?? null,
            upt_jpt_non_asn: unit.UPT["JPT Non PNS"][key] ?? null,
            upt_kontrak: unit.UPT.Kontrak[key] ?? null,
            upt_outsource: unit.UPT.Outsource[key] ?? null,
            jumlah_asn: unit.TOTAL.PNS[key] ?? null,
            jumlah_non_asn: unit.TOTAL.NON_PNS ? unit.TOTAL.NON_PNS[key] : null,
            jumlah_total: unit.TOTAL.SEMUA[key] ?? null,
        }));
    })
}

const transformDataDashboardUsia = (data, target) => {
    if (target === 'list') {
        const filteredData = data.filter((item) => item.rentang_usia !== "Lainnya")
        return filteredData.map((item) => ({
            Pria: item.total_laki_laki,
            Wanita: item.total_perempuan,
            name: `${item.rentang_usia} Tahun`
        }))
    } else {
        const disallowedData = [undefined, null, '']

        const filteredData = data.filter((item) => !disallowedData.includes(item.pegawai__tk_pendidikan_terakhir))
        return filteredData.map((item) => ({
            name: pendidikan[item.pegawai__tk_pendidikan_terakhir],
            Pria: item?.total_laki_laki,
            Wanita: item?.total_perempuan
        }))
    }
}

export default dashboardReducer;